// extracted by extract-css-chunks-webpack-plugin
module.exports = {"subTitle":"subTitle-2LjH0nGx","subTitleLine":"subTitleLine-4hTuRuiw","subTitleLink":"subTitleLink-2bFAE1GM"};